export const colors = {
  brandPrimaryDefault: "#0070EB",
  brandPrimaryTint: "#C8E2FF",
  brandPrimaryShade: "#004EA3",
  contentBrandPrimary: "#0070EB",
  contentLink: "#2B90FF",
  contentLinkActive: "#005FC8",
  backgroundBrand: "#0070EB",
  borderDefault: "#B0B7BF",
  borderSubtle: "#2B2D2E",
  borderDisabled: "#2B2D2E",
  borderBrand: "#0070EB",
  linkDefaultBase: "#2B90FF",
  linkDefaultHover: "#005FC8",
  systemNeutralBackgroundDefault: "#4D5153",
  systemNeutralBorderDefault: "#4D5153",
  componentButtonPrimaryBorderDisabled: "#2B2D2E",
  componentButtonSecondaryBorderDisabled: "#2B2D2E",
  componentButtonTertiaryContentBase: "#2B90FF",
  componentButtonTertiaryBorderBase: "#005FC8",
  componentButtonTertiaryBorderHover: "#005FC8",
  componentButtonTertiaryBorderDisabled: "#2B2D2E",
  componentButtonTransparentBorderDisabled: "#2B2D2E",
  componentButtonDestructiveBorderDisabled: "#2B2D2E",
  componentButtonButtonLinkContentBase: "#2B90FF",
  componentButtonButtonLinkBorderDisabled: "#2B2D2E",
  componentSelectionControlBackgroundHover: "#004EA3",
  componentSelectionControlBackgroundSelected: "#0070EB",
  componentSelectionControlBackgroundSelectedHover: "#0070EB",
  componentSelectionControlBackgroundSelectedActive: "#0070EB",
  componentSelectionControlBackgroundDisabled: "#2B2D2E",
  componentSelectionControlBackgroundSuccess: "#005D23",
  componentSelectionControlBackgroundError: "#A40023",
  componentSelectionControlBorderBase: "#B0B7BF",
  componentSelectionControlBorderHover: "#0070EB",
  componentSelectionControlBorderActive: "#0070EB",
  componentSelectionControlBorderSelected: "#005FC8",
  componentSelectionControlBorderSelectedHover: "#005FC8",
  componentSelectionControlBorderSelectedActive: "#005FC8",
  componentSelectionControlBorderDisabled: "#2B2D2E",
  componentSelectionControlBorderSuccess: "#005D23",
  componentSelectionControlBorderError: "#A40023",
  componentDataInputBorderBase: "#B0B7BF",
  componentDataInputBorderDisabled: "#2B2D2E",
  componentDataInputPasswordMeterEmpty: "#4D5153",
};

export const text = {
  themeName: "Fantasy Dark",
};